import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceRunsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type InvoiceRunsQuery = { __typename?: 'Query', invoiceRuns: Array<{ __typename?: 'InvoiceRun', id: string, type: Types.InvoiceRunType, status: Types.InvoiceRunStatus, year: number, iso_month: number, dry_run: boolean, requested_by?: string | null, enqueued_at: string, due_at?: string | null, started_at?: string | null, finished_at?: string | null, last_activity_at?: string | null, processed_count?: number | null, invoice_count?: number | null, total_count?: number | null, error_count?: number | null, open_error_count: number, parent_run_id?: string | null, parent_run?: { __typename?: 'InvoiceRun', id: string, type: Types.InvoiceRunType, year: number, iso_month: number } | null, charge_run?: { __typename?: 'InvoiceRun', id: string, status: Types.InvoiceRunStatus } | null }> };


export const InvoiceRunsDocument = gql`
    query InvoiceRuns($limit: Int) {
  invoiceRuns(limit: $limit) {
    id
    type
    status
    year
    iso_month
    dry_run
    requested_by
    enqueued_at
    due_at
    started_at
    finished_at
    last_activity_at
    processed_count
    invoice_count
    total_count
    error_count
    open_error_count
    parent_run_id
    parent_run {
      id
      type
      year
      iso_month
    }
    charge_run {
      id
      status
    }
  }
}
    `;

/**
 * __useInvoiceRunsQuery__
 *
 * To run a query within a React component, call `useInvoiceRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceRunsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvoiceRunsQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceRunsQuery, InvoiceRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceRunsQuery, InvoiceRunsQueryVariables>(InvoiceRunsDocument, options);
      }
export function useInvoiceRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceRunsQuery, InvoiceRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceRunsQuery, InvoiceRunsQueryVariables>(InvoiceRunsDocument, options);
        }
export type InvoiceRunsQueryHookResult = ReturnType<typeof useInvoiceRunsQuery>;
export type InvoiceRunsLazyQueryHookResult = ReturnType<typeof useInvoiceRunsLazyQuery>;
export type InvoiceRunsQueryResult = Apollo.QueryResult<InvoiceRunsQuery, InvoiceRunsQueryVariables>;